import { Dialog, Drawer, makeStyles } from "@material-ui/core";
import CrossIcon from "assets/svgs/CrossIcon";
import React from "react";
import RocketCrash from "assets/svgs/RocketCrash";
import { ChevronRight } from "@material-ui/icons";
import { useWindowResize } from "utils/hooks";
import RoundedCloseIcon from "assets/svgs/RoundedCloseIcon";
import RocketCrashMobile from "assets/svgs/RocketCrashMobile";
import Image from "next/image";
import { useRouter } from "next/router";
import { getFinalUrl } from "components/Search/Search";

const useStyles = makeStyles({
	dialog: {
		height: 345,
		maxWidth: 690,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		borderRadius: "8px",
		position: "relative",
	},
	drawer: {
		overflow: "visible",
		borderTopLeftRadius: "16px",
		borderTopRightRadius: "16px",
		padding: "16px",
	},
});

interface JobExpiredModalProps {
	isOpen: boolean;
	handleClose: () => void;
	modalData: {
		heading: string;
		sub_heading: string;
		icon_background_color: string;
		icon: string;
		cta_text: string;
		cta_icon: string;
		icon_mobile: string;
	};
}

const JobExpiredModal: React.FC<JobExpiredModalProps> = ({
	isOpen,
	modalData = {
		heading: "Uh-oh! This job is no longer available",
		sub_heading:
			"It looks like this job has either expired or is no longer accepting applications.",
		icon_background_color: "#DDCA85",
		icon: "https://cdn.apna.co/mumbai_apnatime_prod/job_ui_tags/rocketCrash.svg",
		cta_text: "Explore other jobs",
		cta_icon:
			"https://cdn.apna.co/mumbai_apnatime_prod/job_ui_tags/icon_lagging_3x.webp",
		icon_mobile:
			"https://cdn.apna.co/mumbai_apnatime_prod/job_ui_tags/rocketCrashMobile.webp",
	},
	handleClose,
}) => {
	const classes = useStyles();
	const [isMobileView] = useWindowResize();
	const router = useRouter();
	const {
		heading,
		sub_heading: subHeading,
		icon_background_color: iconBackgroundColor,
		icon,
		cta_text: ctaText,
		cta_icon: ctaIcon,
		icon_mobile: iconMobile,
	} = modalData;

	// const handleExpiredCTAClick = () => {
	// 	const params = new URLSearchParams(window.location.search);
	// 	const newParams = new URLSearchParams();

	// 	const title = JSON.parse(params.get("titleObj")) || {};
	// 	const location = JSON.parse(params.get("locationObj")) || {};
	// 	const experience = JSON.parse(params.get("experienceObj")) || {};

	// 	if (!title?.display_name) {
	// 		handleClose();
	// 		return router.push("/jobs");
	// 	}

	// 	const titleSearch = title.display_name ? title : null;
	// 	const citySearch = Object.keys(location).length > 0 ? location : "empty";
	// 	const experienceSearch =
	// 		Object.keys(experience).length > 0 ? experience : "empty";

	// 	// Only set newParams if location or experience is empty
	// 	if (citySearch === "empty") newParams.set("locationObj", "empty");
	// 	if (experienceSearch === "empty") newParams.set("experienceObj", "empty");

	// 	handleClose();

	// 	const redirectUrl = getFinalUrl(
	// 		titleSearch,
	// 		citySearch === "empty" ? null : citySearch,
	// 		titleSearch?.display_name,
	// 		experienceSearch === "empty" ? null : experienceSearch
	// 	);

	// 	window.open(`${redirectUrl}&${newParams.toString()}`, "_self");
	// 	// Returning a resolved promise to satisfy ESLint's "consistent-return" rule
	// 	return Promise.resolve(true);
	// };

	const handleExpiredCTAClick = () => router.push("/jobs");

	if (isMobileView) {
		return (
			<Drawer
				open={isOpen}
				anchor="bottom"
				classes={{
					paper: classes.drawer,
				}}
			>
				<button
					type="button"
					aria-label="Close"
					onClick={handleClose}
					className="absolute right-[16px] top-[-44px]"
				>
					<RoundedCloseIcon />
				</button>
				<div className="">
					<Image src={iconMobile} width={70} height={32} />
					<div className="my-[16px] flex w-full flex-col justify-center">
						<h1 className="mb-[16px] text-[20px] font-[700] leading-[28px] text-[#190A28]">
							{heading}
						</h1>
						<p className="m-0 p-0 text-[14px] font-[400] leading-[20px] text-[#190A28]">
							{subHeading}
						</p>
					</div>
					<div className="flex h-[96px] w-full items-center justify-center rounded-[4px]">
						<button
							onClick={handleExpiredCTAClick}
							type="button"
							className=" flex h-[48px] w-full items-center justify-center  rounded-[4px] bg-[#1F8268] py-[24px] text-white"
						>
							<span className="text-[16px] font-[600] leading-[24px]">
								{ctaText}
							</span>
							{ctaIcon && <Image src={ctaIcon} height={24} width={24} />}
						</button>
					</div>
				</div>
			</Drawer>
		);
	}
	return (
		<Dialog
			open={isOpen}
			classes={{
				paper: classes.dialog,
			}}
		>
			<div className="relative h-[345px] w-[690px] rounded-[8px] bg-white">
				<CrossIcon
					className="absolute right-[16px] top-[16px] cursor-pointer"
					onClick={handleClose}
				/>
				<div
					className="flex h-[160px] w-full items-center justify-center overflow-hidden"
					style={{ backgroundColor: iconBackgroundColor }}
				>
					{icon && <Image src={icon} width={228} height={192} />}
				</div>
				<div className="my-[24px] flex flex-col items-center justify-center">
					<h1 className="m-0 text-[20px] font-[700] leading-[28px] text-[#190A28]">
						{heading}
					</h1>
					<p className="m-0 p-0 text-[16px] font-[400] leading-[24px] text-[#190A28]">
						{subHeading}
					</p>
				</div>
				<button
					onClick={handleExpiredCTAClick}
					type="button"
					className="mx-auto flex h-[48px] w-[422px] items-center justify-center rounded-[4px] bg-[#1F8268] text-white"
				>
					<span className="text-[16px] font-[600] leading-[24px]">
						{ctaText}
					</span>
					{ctaIcon && <Image src={ctaIcon} height={24} width={24} />}
				</button>
			</div>
		</Dialog>
	);
};

export default JobExpiredModal;
